module.exports = __webpack_public_path__ + "static/media/robyn_new.ca1af3c1.jpeg";